import React from 'react';
export const OptionPullDown = (props) => {

    let def;
    props.data.map((value,index) =>{
        if(value.selected){
            def = value.id;
        }
    })

    const option = props.data.map((value,index) =>
            <option key={index} value={value.id}>
                {value.value}
            </option>
    );
    return(
        <select 
            id ={props.id}
            className={props.selectClass}
            value={props.state}
            onChange={props.onChange}
            defaultValue={def}>
            {option}
        </select>
    );
}